import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = {
  class: "d-flex justify-content-between align-items-center flex-wrap gap-3",
  style: {"padding-bottom":"33px"}
}
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = { style: {"margin":"-24px 13px -21px -18px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Employee Attendance Trends", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DateRangePicker),
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-calendar-line position-absolute top-50 start-0 translate-middle-y ps-3 fs-15" }, null, -1))
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("ul", {
        class: "ps-0 mb-0 list-unstyled d-flex flex-wrap justify-content-between gap-2 lh-1 employee-attendance-list",
        style: {"padding-bottom":"45px"}
      }, [
        _createElementVNode("li", null, [
          _createTextVNode("Avg. Daily Attend: "),
          _createElementVNode("span", { class: "fw-semibold" }, "320")
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(" High. Attend: "),
          _createElementVNode("span", { class: "fw-semibold" }, "340"),
          _createTextVNode(" (October 5th) ")
        ]),
        _createElementVNode("li", null, [
          _createTextVNode("Low. Attend: "),
          _createElementVNode("span", { class: "fw-semibold" }, "290"),
          _createTextVNode(" (October 1st)")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "388",
              options: _ctx.employeeAttendanceTrends,
              series: _ctx.attendance
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}